import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-744c4947"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "audit-info" }
const _hoisted_2 = {
  key: 0,
  class: "audit-date"
}
const _hoisted_3 = {
  key: 1,
  class: "audit-date"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.mode === 'date' && _ctx.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.formatDate(_ctx.value)), 1))
      : (_ctx.mode === 'datetime' && _ctx.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.formatDateTime(_ctx.value)), 1))
        : _createCommentVNode("", true)
  ]))
}